var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = { disabled: _vm.disabled }, _obj[_vm.styleType] = true, _obj )},[_vm._t("label",[(_vm.label)?_c('ui-label',{attrs:{"name":_vm.name,"text":_vm.label,"help-tooltip":_vm.labelHelp}}):_vm._e()]),_c('div',{staticClass:"ui-radio",class:[{ 'horizontal-line': _vm.horizontalLine },_vm.spaceBetweenLabelAndRadio]},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }